import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { TreeItem } from '@mui/x-tree-view';
import { useTranslation } from 'react-i18next';
import { Suspense } from 'react';
import 'shared/translate-config/i18n';
import { CheckboxForTree } from 'shared/device.z3k.tree-view-compare/ui/checkbox-for-tree';
export const TreeViewString = (props) => {
    const { t } = useTranslation();
    const { indexSetter, data, newSetter, keyResult, onCheckNewConfig } = props;
    const settings = data.el[0].setter.settings;
    return (_jsx(Suspense, { fallback: "loading", children: _jsx(TreeItem, { itemId: `${indexSetter}`, label: onCheckNewConfig ? (_jsx(CheckboxForTree, { newSetter: newSetter, keyResult: keyResult, setter: data.el[0].setter, onCheckNewConfig: onCheckNewConfig, data: data, labelForComponent: _jsxs(Typography, { variant: "inherit", children: [t(`${data.key}.key`), ": ", JSON.stringify(settings)] }) })) : (_jsxs(Typography, { variant: "inherit", children: [t(`${data.key}.key`), ": ", JSON.stringify(settings)] })) }) }));
};
